const deletableApiKeyStatuses = new Set(['Active', 'Revoked', 'Expired'])

interface ApiKeyStatusFlags {
  isDeleting: boolean
  isRevoked: boolean
  isExpired: boolean
  isIssued: boolean
}

export const getApiKeyStatus = ({
  isDeleting,
  isRevoked,
  isExpired,
  isIssued
}: ApiKeyStatusFlags) => {
  if (isDeleting) return 'Deleting'
  if (isRevoked) return 'Revoked'
  if (isExpired) return 'Expired'
  if (isIssued) return 'Active'
  return 'Creating'
}

export const isApiKeyDeletable = (status?: string) => {
  return status !== undefined && deletableApiKeyStatuses.has(status)
}
